import { supabase } from './supabase'

// Taie slash-urile de la final ca sa nu apara `//` in URL (redirect interzis la preflight CORS)
export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3000').replace(/\/+$/, '')

/**
 * Fetch catre backend-ul propriu cu tokenul Supabase atasat automat.
 * @param {string} path - ex. '/create-checkout-session'
 * @param {object} options - optiuni fetch (method, body deja stringified, etc.)
 */
export async function authedFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token

  return fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  })
}
